import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['properties_360', 'weather'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({}),
      }),
      makeHttpParamsUrl: (id) =>
        `${process.env.WEATHER_BASE_URI}/properties/${id}/stations`,
    })
  );

  const basePlugin = new BaseModulePlugins({
    paramId: 'propertyId',
    module: 'properties_360/weather',
    store,
  });

  basePlugin.onInit(() => {
    basePlugin.loadItemsOnRouteParamsChange();
    basePlugin.onActiveRequestChange((request) => {
      store.dispatch(
        `properties_360/weather/setUrlParamIdAndClearFilters`,
        request.property_id
      );
    });
  });
};
